import React from 'react';
import { Field } from 'react-final-form';
import { NumericFormat } from 'react-number-format';
import FieldWithNoValidation from '../FieldWithNoValidation';
import { useTheme } from '../../context/ThemeContext';
import styled from 'styled-components';
import colors from '../../globalStyles.scss';

const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    input {
        color: ${props => props.theme === 'dark' ? colors.white : colors.darkGray};
        color: ${props => props.showLightColors && colors.white};
        background: ${props => props.disabled ? (props.theme === 'dark' ? colors.disabledDark : colors.lightBlue) : (props.theme === 'dark' ? colors.backgroundSecondary : colors.darkGray)} !important;

    }
`;

const AmountField = ({
    input,
    meta,
    name,
    label,
    setIsEditing,
    validate,
    disabled,
    ...rest
}) => {

    const handlePriceChange = ({ floatValue }) => {
        input.onChange(floatValue);
        if (setIsEditing) {
            if (input.value !== floatValue) {
                setIsEditing(true);
            }
        }
    };

    const getCurrencyPrefix = () => {
        return '$';
    };

    return (
        <div>
            <NumericFormat
                onValueChange={handlePriceChange}
                thousandSeparator={true}
                prefix={getCurrencyPrefix(input.value)}
                allowNegative={false}
                decimalScale={2}
                fixedDecimalScale={true}
                isNumericString={true}
                customInput={FieldWithNoValidation}
                value={input.value}
                placeholder={'$0.00'}
                validate={validate}
                disabled={disabled}
                {...rest}
            />
            {meta.touched && meta.error && <span>{meta.error}</span>}
        </div>
    );
};

export const AmountInput = ({
    name,
    label,
    showLightColors = false,
    validate,
    className,
    disabled,
    ...rest
}) => {
    const { theme } = useTheme();

    return (
        <StyledDiv
            showLightColors={showLightColors}
            theme={theme}
            className={className}
            disabled={disabled}
        >
            <label className='custom-label b flex'>{label}</label>
            <div className='custom-field'>
                <Field
                    name={name}
                    component={AmountField}
                    showLightColors={showLightColors}
                    validate={validate}
                    disabled={disabled}
                    {...rest}
                />
            </div>
        </StyledDiv>
    );
};

export default AmountInput;
